Ext.define('SA.Html', {
    extend: 'SA.Dom',

    statics: {
        createInstance() {
            SA.Html = new SA.Html();
        }
    },

    addCapturingListener(eventName, cb) {
        document.body.addEventListener(eventName, cb, {capture: true});

        return {destroy: () => document.body.removeEventListener(eventName, cb, {capture: true})};
    },

    create(params) {
        if (Ext.isObject(params)) {
            params = {type: 'div', ...params}; 
        }

        return this.callParent([params]);
    },

    createEl(type) {
        return document.createElement(type);
    },

    getSize(el) {
        var {width, height} = el.getBoundingClientRect();

        return {width, height};
    },

    parse(html) {
        var div = this.create({type: 'div'}),
            el;

        div.innerHTML = Array.isArray(html) ? html.join('\n') : html;
        el = div.firstChild;

        el.remove();

        return el;
    },

    setAttrImpl(el, property, value) {
        el.setAttribute(property, value);
    },

    setChild(parent, child) {
        parent.textContent = '';

        return parent.appendChild(child);
    },

    setMaxSize(el, maxSize) {
        el.style.maxWidth = `${maxSize.width}px`;
        el.style.maxHeight = `${maxSize.height}px`;
    },

    setSize(el, size) {
        var width = `${size.width}px`,
            height = `${size.height}px`;

        this.applyStyles(el, {width, height});
    }
}, function(cls) {
    cls.createInstance();
});